export default {
  topMenu: {
    'openSettings': 'Apri impostazioni',
    'showAbout': 'Mostra informazioni generali',
    'about': 'Chi siamo',
    'pinSidebar': 'Barra laterale di default',
    'settingsTooltip': 'Clicca qui se vuoi cambiare le impostazioni dell\'applicazione'
  }
}
